module.exports = __webpack_public_path__ + "img/perforaciones_3-4_1152.2a91d2f6.webp";